/* Trend Tonic product page · tt-product.js (needs tt-landing.js, loaded before it by tt-assets) */
(function () {
  if (window.TTProduct) { window.TTProduct.init(document); return; }

  function whenReady(fn) {
    if (window.TTLanding && window.TTLanding.slider) return fn();
    var n = 0, t = setInterval(function () { if (window.TTLanding && window.TTLanding.slider) { clearInterval(t); fn(); } else if (++n > 100) clearInterval(t); }, 50);
  }

  /* ---------- gallery ---------- */
  function initGallery(g) {
    if (g._tt) return; g._tt = true;
    var track = g.querySelector('[data-tt-gal-track]');
    if (!track) return;
    var slides = [].slice.call(track.children);
    var thumbs = [].slice.call(g.querySelectorAll('[data-tt-thumb]'));
    var cur = g.querySelector('[data-tt-gal-cur]');
    var prev = g.querySelector('[data-tt-gal-prev]'), next = g.querySelector('[data-tt-gal-next]');
    var map = {};
    try { map = JSON.parse(g.querySelector('[data-tt-variant-media]').textContent || '{}'); } catch (e) {}

    var slider = window.TTLanding.slider(track, {
      dots: g.querySelector('[data-tt-gal-dots]'),
      mouse: true,
      autoHeight: g.classList.contains('tt-gal--adapt'),
      onChange: function (i, el) {
        if (cur) cur.textContent = i + 1;
        var id = el && el.getAttribute('data-media-id');
        thumbs.forEach(function (t) {
          var on = t.getAttribute('data-tt-thumb') === id;
          t.setAttribute('aria-current', on ? 'true' : 'false');
          if (on) { var p = t.parentElement; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, top: t.offsetTop - p.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' }); }
        });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        // pause videos that scrolled away
        slides.forEach(function (s, k) { if (k !== i) s.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} }); });
      }
    });
    function goId(id, smooth) { var el = track.querySelector('[data-media-id="' + id + '"]'); if (el) slider.goToEl(el, smooth); }
    prev && prev.addEventListener('click', slider.prev);
    next && next.addEventListener('click', slider.next);
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goId(t.getAttribute('data-tt-thumb')); }); });

    // start on the selected variant's image
    var start = g.getAttribute('data-start');
    requestAnimationFrame(function () { if (start) goId(start, false); else slider.go(0, false); });

    // follow variant changes (Dawn publishes variantChange; fall back to watching the form)
    var info = g.closest('product-info') || document;
    function syncFromVariant(vid) { if (vid && map[vid]) goId(map[vid]); }
    // Dawn declares PUB_SUB_EVENTS / subscribe as globals (not window properties)
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var d = ev && ev.data; if (!d || !d.variant) return;
        var mine = info.getAttribute && info.getAttribute('data-section');
        if (mine && d.sectionId && d.sectionId !== mine) return;
        if (d.variant.featured_media) goId(d.variant.featured_media.id); else syncFromVariant(d.variant.id);
      });
    } else {
      // non-Dawn themes: watch the variant id input until it changes
      info.addEventListener('change', function (e) {
        if (!e.target.closest('variant-selects, variant-radios, .product-form__input')) return;
        var inp = info.querySelector('form[action*="/cart/add"] input[name="id"]'); if (!inp) return;
        var old = inp.value, tries = 0;
        var t = setInterval(function () { if (inp.value !== old || ++tries > 30) { clearInterval(t); syncFromVariant(inp.value); } }, 100);
      });
    }
    // 3D models: load Shopify's model viewer and let drags rotate the model
    if (track.querySelector('model-viewer') && window.Shopify && Shopify.loadFeatures) {
      try { Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: function () {} }]); } catch (e) {}
    }

    // zoom
    var lb = g.querySelector('[data-tt-lightbox]');
    if (lb) {
      var close = lb.querySelector('[data-tt-lightbox-close]');
      function open(i) {
        lb.hidden = false; document.documentElement.classList.add('tt-lock-lb');
        var item = lb.querySelector('[data-lb-index="' + i + '"]');
        setTimeout(function () { if (item) item.scrollIntoView({ block: 'start' }); close.focus(); }, 30);
      }
      function shut() { lb.hidden = true; document.documentElement.classList.remove('tt-lock-lb'); }
      g.querySelectorAll('[data-tt-zoom]').forEach(function (b) { b.addEventListener('click', function () { open(b.getAttribute('data-tt-zoom')); }); });
      track.addEventListener('click', function (e) {
        var img = e.target.closest('.tt-gal__img'); if (!img) return;
        var z = img.parentElement.querySelector('[data-tt-zoom]'); if (z) open(z.getAttribute('data-tt-zoom'));
      });
      close.addEventListener('click', shut);
      lb.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
    }
  }

  /* ---------- delivery estimate ---------- */
  function initDelivery(d) {
    if (d._tt) return; d._tt = true;
    var tz = d.getAttribute('data-tz') || 'Europe/London';
    var days = (d.getAttribute('data-days') || '1,2,4').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x >= 1 && x <= 7; });
    var cutoff = parseInt(d.getAttribute('data-cutoff') || '12', 10);
    var tmin = parseInt(d.getAttribute('data-min') || '1', 10), tmax = parseInt(d.getAttribute('data-max') || '3', 10);
    var tOrder = d.getAttribute('data-order') || '', tArrive = d.getAttribute('data-arrive') || '';
    var elOrder = d.querySelector('[data-tt-del-order]'), elArrive = d.querySelector('[data-tt-del-arrive]');
    if (!days.length) return;
    function nowParts() {
      try {
        var f = new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false });
        var p = {}; f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        return new Date(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
      } catch (e) { return new Date(); }
    }
    function iso(dt) { var w = dt.getDay(); return w === 0 ? 7 : w; }
    function addWorkdays(dt, n) { var x = new Date(dt); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0) n--; } return x; } // Royal Mail delivers Mon–Sat
    function fmtDay(dt, now) {
      var diff = Math.round((new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 864e5);
      if (diff === 0) return 'today'; if (diff === 1) return 'tomorrow';
      return 'on ' + dt.toLocaleDateString('en-GB', { weekday: 'long' });
    }
    function fmtDate(dt) { return dt.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
    function render() {
      var now = nowParts(), disp = new Date(now);
      disp.setHours(cutoff, 0, 0, 0);
      for (var i = 0; i < 14; i++) {
        if (days.indexOf(iso(disp)) > -1 && disp > now) break;
        disp.setDate(disp.getDate() + 1); disp.setHours(cutoff, 0, 0, 0);
      }
      var ms = disp - now, h = Math.floor(ms / 36e5), m = Math.floor(ms % 36e5 / 6e4);
      var cd = h >= 24 ? Math.floor(h / 24) + 'd ' + (h % 24) + 'h' : h + 'h ' + m + 'm';
      elOrder.innerHTML = tOrder.replace('[countdown]', '<b>' + cd + '</b>').replace('[day]', '<b>' + fmtDay(disp, now) + '</b>');
      var a = addWorkdays(disp, tmin), b = addWorkdays(disp, Math.max(tmin, tmax));
      if (elArrive && tArrive) elArrive.textContent = tArrive.replace('[from]', fmtDate(a)).replace('[to]', fmtDate(b));
    }
    render(); setInterval(render, 60000);
  }

  /* ---------- sticky add to bag ---------- */
  function initSticky(bar) {
    if (bar._tt) return; bar._tt = true;
    var info = document.querySelector('product-info.tt-pdp') || document.querySelector('product-info');
    if (!info) return;
    var mainBtn = info.querySelector('.product-form__submit');
    var btn = bar.querySelector('[data-tt-satc-btn]'), price = bar.querySelector('[data-tt-satc-price]'), vEl = bar.querySelector('[data-tt-satc-variant]');
    var addTxt = btn.getAttribute('data-add') || btn.textContent;
    var scrollMode = bar.getAttribute('data-mode') === 'scroll';
    function sync() {
      if (!mainBtn) mainBtn = info.querySelector('.product-form__submit');
      var pr = info.querySelector('.price');
      if (pr && price) {
        var sale = pr.classList.contains('price--on-sale') ? pr.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last') : null;
        var reg = pr.querySelector('.price__regular .price-item--regular');
        var t = (sale || reg || pr).textContent.replace(/\s+/g, ' ').trim();
        price.textContent = t;
      }
      if (vEl) {
        var checked = [].slice.call(info.querySelectorAll('variant-selects input:checked, variant-selects select')).map(function (x) { return x.tagName === 'SELECT' ? x.options[x.selectedIndex].text : x.value; });
        vEl.textContent = checked.length ? ' · ' + checked.join(' / ') : '';
      }
      if (mainBtn && !scrollMode) {
        var dis = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
        btn.disabled = dis;
        btn.textContent = dis ? (mainBtn.textContent.trim() || 'Sold out') : addTxt;
      }
    }
    btn.addEventListener('click', function () {
      if (scrollMode) { info.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (!mainBtn || mainBtn.disabled) return;
      mainBtn.click();
    });
    new MutationObserver(function () { clearTimeout(bar._t); bar._t = setTimeout(sync, 60); }).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'class', 'checked'] });
    info.addEventListener('change', function () { setTimeout(sync, 500); });
    sync();
    var target = mainBtn || info;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0], past = (!e.isIntersecting && e.boundingClientRect.top < 0) || !!(window.Shopify && Shopify.designMode);
        bar.classList.toggle('is-on', past); bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        btn.tabIndex = past ? 0 : -1;
      }).observe(target);
    }
    if (window.Shopify && Shopify.designMode) bar.classList.add('is-on');
  }

  function init(scope) {
    scope = scope || document;
    whenReady(function () { scope.querySelectorAll('[data-tt-gallery]').forEach(initGallery); });
    scope.querySelectorAll('[data-tt-delivery]').forEach(initDelivery);
    scope.querySelectorAll('[data-tt-satc]').forEach(initSticky);
  }
  window.TTProduct = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Dawn quick-add modal / combined-listing swaps load new product-info markup
  document.addEventListener('product-info:loaded', function (e) { init(e.target || document); });
})();
